module.exports = new __parcel__URL__("toolbox.d2bfa8dc.svg").toString();